<template>
	<div class="list-container">

		<div class="list-subtitle"><b>{{ getString('range') }}</b></div>
		<div class="list-item">
			<p class="list-item-title">{{ getString('from') }}</p>
			<AppNumberInput symbol="€" :min="0" :increment="1" type="number" :value="Number(item.min/100)" @changed-value="(val) => { $emit('changed-value', 'min', val*100) }" />
		</div>
		<div class="list-item">
			<p class="list-item-title">{{ getString('to') }}</p>
			<AppSwitch :disabled="!!item.disabled" :checked="!!item.toActive" class="switch" @switched="(newVal)=>itemSwitched(item, newVal)" :ref="item.ref ? item.ref : 'switch'" />
		</div>
		<AppDropdown :collapsed="!item.toActive">
			<AppNumberInput v-if="item.max" symbol="€" :min="0.01" :increment="1" type="number" :value="Number(item.max/100)" @changed-value="(val) => { $emit('changed-value', 'max', val*100) }" />
		</AppDropdown>
		<hr>
		<div class="list-subtitle"><b>{{ getString('stripe') }}</b></div>
		<div class="list-item">
			<p class="list-item-title">{{ getString('fixed_commissions_param', [(readableEurValue(item.fixed/100))]) }}</p>
			<AppNumberInput symbol="€" :min="0" :increment="0.1" type="number" :value="item.fixed/100" @changed-value="(val) => { $emit('changed-value', 'fixed', val*100) }" />
		</div>
		<div class="list-item">
			<p class="list-item-title">{{ getString('percentage_commissions_param', [Number(item.percent)]) }}</p>
			<AppNumberInput symbol="%" :min="0" :max="100" :increment="0.1" type="number" :value="Number(item.percent)" @changed-value="(val) => { $emit('changed-value', 'percent', val) }" />
		</div>
		<div class="list-item">
			<p class="list-item-title">{{ getString('percentage_commissions_surplus_param', [Number(item.premium)]) }}</p>
			<AppNumberInput symbol="%" :min="0" :max="100" :increment="0.1" type="number" :value="Number(item.premium)" @changed-value="(val) => { $emit('changed-value', 'premium', val) }" />
		</div>
		<hr v-if="type === 'standard'">
		<div class="list-subtitle" v-if="type === 'standard'"><b>{{ getString('alternative') }}</b></div>
		<div class="list-item" v-if="type === 'standard'">
			<p class="list-item-title">{{ getString('fixed_commissions_param', [(readableEurValue(item.fixed/100))]) }}</p>
			<AppNumberInput symbol="€" :min="0" :increment="0.1" type="number" :value="item.alternative_fixed/100" @changed-value="(val) => { $emit('changed-value', 'altfixed', val*100) }" />
		</div>
		<div class="list-item" v-if="type === 'standard'">
			<p class="list-item-title">{{ getString('percentage_commissions_param', [Number(item.alternative_percent)]) }}</p>
			<AppNumberInput symbol="%" :min="0" :max="100" :increment="0.1" type="number" :value="Number(item.alternative_percent)" @changed-value="(val) => { $emit('changed-value', 'altpercent', val) }" />
		</div>

	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {useSuperStore} from "@/user/stores";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";

export default {
	components: {AppSwitch, AppDropdown, AppNumberInput},
	setup() {
		const languageStore = useLanguageStore();
		const superStore = useSuperStore();
		return {getString: languageStore.getString, readableEurValue: languageStore.readableEurValue, superStore}
	},
	name: "FeeRulesAppList",
	emits: ["changed-value"],
	props: {
		item:  {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		}
	},
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		itemSwitched(item, newVal) {
			item.toActive = newVal;
			if ( ! newVal ) {
				this.$emit('changed-value', 'max', null);
			} else {
				this.$emit('changed-value', 'max', (item.min)+1);
			}
			if(item.callback) {
				item.callback(newVal);
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.list-container {
	width: 100%;

	.list-item {
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;

		.switch {
			margin-left: auto;
		}

		.list-subtitle {
			font-size: 80%;
			color: #6c33cb;
			margin: 10px 0;
		}

		.list-item-title {
			text-transform: capitalize;
			min-width: 180px;
		}

	}

	.list-item:first-child {
		margin-top: 0;
	}

	hr {
		margin-top: 10px;
		border-color: var(--color-alpha-3);
		border-width: 1px 0 0 0;
	}

	:deep(.dropdown-content) {
		display: flex;
		justify-content: end;
	}
}
</style>